function onEnterVrClick() {
  const { onEnterVr } = this.props;
  if (onEnterVr && typeof onEnterVr === 'function') {
    onEnterVr();
  }
}
function onExitVrClick() {
  const { onExitVr } = this.props;
  if (onExitVr && typeof onExitVr === 'function') {
    onExitVr();
  }
}
function exitVr() {
  if (!this.krpano) return;
  this.krpano.call('webvr.exitVR();');
}
function enterVr() {
  if (!this.krpano) return;
  this.krpano.call('webvr.enterVR();');
}
export default {
  onEnterVrClick,
  onExitVrClick,
  exitVr,
  enterVr,
};
